import { defineMessages } from 'react-intl';

export default defineMessages({
  header: '404',
  content: 'The page does not exist.',
});
